import React from "react";

const TemplateSelectContext = React.createContext({});
export const TemplateSelectProvider = TemplateSelectContext.Provider;
export default TemplateSelectContext;
